module.exports = __webpack_public_path__ + "media/images/a2-3b431c79cc258e440e05bffd44c88a58.jpg";